export enum PlanningSidebarType {
  MACHINE,
  PLANNING_ITEM,
  PLANNING_ORDER,
  NEEDS_ATTENTION
}
